import { PATIENT_ACTION } from "core/consts";
import { PatientActionType } from "core/types";
import { encryptedField, encryptionContext } from "./fragments";

const clinicalConsultationFragment = `
  id
  created_at
  updated_at
  profile {
    ${encryptedField("first_name")}
    ${encryptedField("last_name")}
    ${encryptedField("birth_date")}
    gender
  }
  clinical_consultations {
    id
    created_at
    updated_at
    patient_id
    seald_encryption_context {
      ${encryptionContext()}
    }
  }
  seald_encryption_context {
    ${encryptionContext()}
  }
`;

const patientActionFragments: {
  [action in PatientActionType]: string;
} = {
  [PATIENT_ACTION.CREATE_CLINICAL_CONSULTATION]: clinicalConsultationFragment,
};

export default patientActionFragments;
